import { Directive, ElementRef, HostListener, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
    selector: '[appDomainSuffixHref]',
})
export class AddSportsSuffixHrefDirective implements OnChanges {
    @Input() linkHref?: string;
    @Input() link?: string;
    private href: string | undefined;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private router: Router,
    ) {}

    /**
     * Useful for setting en/sports prefix and then navigating to the url
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        this.href = this.linkHref || this.link;

        if (this.href && this.href.startsWith('/') && !this.href.startsWith('/en/sports')) {
            this.href = `/en/sports${this.href}`;
        }

        this.renderer.setAttribute(this.el.nativeElement, 'href', this.href || '');
    }

    /**
     * Useful for doing in app Navigation
     * @param event
     */
    @HostListener('click', ['$event'])
    onClick(event: MouseEvent) {
        if (this.href && this.href.startsWith('/')) {
            event.preventDefault();
            this.router.navigateByUrl(this.href);
        }
    }
}
